module.exports = __webpack_public_path__ + "static/media/ZSCE_MP_REAB.674529ac.pdf";